import PropTypes from 'prop-types';

const ArrowIcon = ({ fill, width = '23', height = '16', className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 83.641'
    fill={fill}
    width={width}
    height={height}
    className={className}
  >
    <polygon points='58.263,0.056 100,41.85 58.263,83.641 30.662,83.641 62.438,51.866 0,51.866 0,31.611 62.213,31.611 30.605,0 58.263,0.056' />
  </svg>
);

ArrowIcon.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ArrowIcon;
